import React, { Component } from 'react';
import SkillThumb from '../skills/SkillThumb'
import UnrealLogo from '../../images/logos/UnrealEngineWhiteLogo.png'
import UnityLogo from '../../images/logos/UnityWhiteLogo.png'

class Skills extends Component {
  render() {
    return (
    <div className="page light-dark-background" id={this.props.id}>
        <div className="page-container ">
            <h2>Skills </h2>

            <div className='skills-list'>
            <SkillThumb image={UnityLogo} alt="Unity Logo" description="Game & Editor development"/>
            <SkillThumb image={UnrealLogo} alt="Unreal Logo" description="Blueprint & C++"/>
            </div>
        </div>
    </div>
    );
  }
}

export default Skills;